<template>
    <div>
        <v-row>
            <v-col>

                <!-- DISTRIBUTOR -->
                <template v-if="isNewSearch">
                    <BaseEditPageDropdownAz
                        :context="context +'PricelistsRows'"
                        field="Distributor"
                        :items="getDistributorDropdownItems"
                        :selection="true"
                        rules="required"
                        :clearable="false"
                        :withMargin="false"
                        :label="$t('lang_ERP_PRICELISTS_CAPTION_DISTRIBUTOR')"
                        :alvqa="alvqa + '-dropdown-pricelists-distributor'"
                    /> 
                </template>

                <template v-else>
                     <BaseEditPageDropdownAz
                        :context="context +'PricelistsRows'"
                        field="Distributor"
                        :items="getDistributorDropdownItems"
                        :selection="true"
                        rules="required"
                        :clearable="false"
                        :withMargin="false"
                        :label="$t('lang_ERP_PRICELISTS_CAPTION_DISTRIBUTOR')"
                        :alvqa="alvqa + '-dropdown-pricelists-distributor'"
                        :disabled="true"
                    /> 
                </template>

            </v-col>
        </v-row>

        <v-row>

            <!-- MSP -->
            <v-col cols="2">
                <BaseEditPageTextField 
                    :context="context +'PricelistsRows'"
                    field="Msp"
                    :label="$t('lang_GENERIC_LABEL_CAPTION_MSP')"
                    :iconTooltipText="$t('lang_ERP_PRICELISTS_TOOLTIP_MSP')"
                    rules="amountMaxTwoDigits"
                    :withMargin="false"
                    :alvqa="alvqa + '-textfield-msp'"
                />
            </v-col>

            <!-- PPD -->
            <v-col cols="2">
                <BaseEditPageTextField 
                    :context="context +'PricelistsRows'"
                    field="Ppd"
                    :label="$t('lang_GENERIC_LABEL_CAPTION_PPD')"
                    :iconTooltipText="$t('lang_ERP_PRICELISTS_TOOLTIP_PPD')"
                    rules="amountMaxTwoDigits"
                    :withMargin="false"
                    :alvqa="alvqa + '-textfield-ppd'"
                />
            </v-col>

            <!-- SRP -->
            <v-col cols="2">
                <BaseEditPageTextField 
                    :context="context +'PricelistsRows'"
                    field="Srp"
                    :label="$t('lang_GENERIC_LABEL_CAPTION_SRP')"
                    :iconTooltipText="$t('lang_ERP_PRICELISTS_TOOLTIP_SRP')"
                    rules="amountMaxTwoDigits"
                    :withMargin="false"
                    :alvqa="alvqa + '-textfield-srp'"
                />
            </v-col>

            <!-- SPS -->
            <v-col cols="2">
                <BaseEditPageTextField 
                    :context="context +'PricelistsRows'"
                    field="Sps"
                    :label="$t('lang_GENERIC_LABEL_CAPTION_SPS')"
                    :iconTooltipText="$t('lang_ERP_PRICELISTS_TOOLTIP_SPS')"
                    rules="amountMaxTwoDigits"
                    :withMargin="false"
                    :alvqa="alvqa + '-textfield-sps'"
                />
            </v-col>

            <!-- CURRENCY -->
            <v-col cols="4">
                <BaseEditPageDropdown 
                    :context="context +'PricelistsRows'"
                    field="Currency"
                    :items="dropdownCurrency" 
                    :label="$t('lang_ACCOUNT_COMPANIES_CAPTION_CURRENCY')"
                    :selection="true"
                    :withMargin="false"
                    :alvqa="alvqa + '-dropdown-currency'"
                />
            </v-col>

        </v-row>

        <v-row>

            <!-- PRICE CATEGORY -->
            <v-col cols="4">
                <BaseEditPageDropdown 
                    :context="context +'PricelistsRows'"
                    field="PriceCategory"
                    :items="dropdownPriceCategory" 
                    :label="$t('lang_ERP_PRICELISTS_CAPTION_PRICE_CATEGORY')"
                    :selection="true"
                    :withMargin="false"
                    :alvqa="alvqa + '-dropdown-price-category'"
                />
            </v-col>

            <!-- REGIONS -->
            <v-col cols="8">
                <BaseEditPageTextField 
                    :context="context +'PricelistsRows'"
                    field="Regions"
                    :label="$t('lang_GENERIC_CAPTION_REGIONS_DEFINITION')"
                    :withMargin="false"
                    rules="listTwoCharacterWordsWithCommas"
                    :iconTooltipText="$t('lang_ERP_PRICELISTS_TOOLTIP_REGIONS')"
                    :clearable="true"
                    :alvqa="alvqa + '-textfield-regions-definition'"
                />
            </v-col>

        </v-row>

    </div>
</template>

<script>
import BaseEditPageTextField    from '@/components/_editForm/BaseEditPageTextField'
import BaseEditPageDropdown     from '@/components/_editForm/BaseEditPageDropdown'
import BaseEditPageDropdownAz   from '@/components/_editForm/BaseEditPageDropdownAz'
import { DropdownGeneralPriceCategories,
         DropdownCurrencies, } from '@/assets/dropdowns/alvDropdowns.js'

export default {
    name: "PricelistsRowsEditPanelDialog",
    components: {
        BaseEditPageTextField,
        BaseEditPageDropdown,
        BaseEditPageDropdownAz,
        DropdownGeneralPriceCategories,
        DropdownCurrencies,
    },
    data() {
        return {
            context: "Pricelists",
            alvqa: "erp-pricelists-edit-panel-pricelists-rows-dialog"
        }
    },

    computed: {
        
        getDistributorDropdownItems() {
            return this.$store.getters.getPricelistsPricelistsRowsDistributorOptions
        },

        dropdownCurrency() {
            return DropdownCurrencies
        },

        dropdownPriceCategory() {
            return DropdownGeneralPriceCategories
        },

        isNewSearch() {
            let isNewSearch = this.$store.getters.getPricelistsPricelistsRowsIsNewSearch
            return isNewSearch        
        }

    },

    // // PT: Moved to EditPanel because it took too long in Dialog
    // created() {
    //     this.$store.dispatch('fetchDropdownPricelistsDistributor', ['vertrieb'])
    // }
}
</script>